module.exports = __webpack_public_path__ + "static/media/Close Default.7ee24d64.svg";